import { mapActions, mapState } from 'vuex';

import {
  SNACKBAR_TYPES,
} from '@/utils/constants';

export default {
  name: 'CancelOrder',
  props: {
    orderName: {
      default: '',
      type: String,
    },
    orderUuid: {
      default: null,
      type: String,
    },
    value: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapState('order', {
      canceling: ({ cancelingOrder }) => cancelingOrder,
    }),
  },
  methods: {
    ...mapActions('order', {
      cancelOrder: 'CANCEL_ORDER',
      clearOrders: 'CLEAR_ORDERS',
      getOrders: 'GET_ORDERS',
    }),
    async cancel() {
      try {
        const res = await this.cancelOrder(this.orderUuid);
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, msg: '取消成功' });
        this.$emit('success', res);
        this.close();
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '取消失敗',
          msg,
        });
      }
    },
    close() {
      this.$emit('input', false);
      this.$emit('close');
    },
  },
};
